import { render, staticRenderFns } from "./six4.vue?vue&type=template&id=01ae6e5a&"
import script from "./six4.vue?vue&type=script&lang=js&"
export * from "./six4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports